/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-03-23 17:15:14
 * @LastEditors: limin
 * @LastEditTime: 2021-04-14 20:43:34
 */
import {ADDRESS_GET_ADDRESS_LIST,ADDRESS_SET_ACTIVE_ADDRESS,ADDRESS_SET_DEFAULT_ADDRESS} from '../types' // types目录下的mutations函数的常量名
import apis from '@/apis'
import router from "../../router/index.js";

const { address:{ get,add,remove,setDefault,edit } } = apis
const state = {
  address: [], // 存放所有地址信息
}

const getters = {
  allAddress(state){
    return  state.address
  },
  activeAddress(state){
    return  state.address.find(addr=>addr.isActive)
  },
  defaultAddress(state){
    return  state.address.find(addr=>addr.isDefault)
  },
  selectAddress(state,getters){
    const { activeAddress,defaultAddress } = getters
    return activeAddress || defaultAddress || state.address[0] || state.address
  },
  selectAddressDetail(state,getters){
    const { selectAddress:{province,city,county,addressDetail} } = getters
    return province+city+county+addressDetail || ''
  }
}

const mutations = {
  [ADDRESS_GET_ADDRESS_LIST](state, adds) {
    state.address = adds
  },
  [ADDRESS_SET_ACTIVE_ADDRESS](state, id) {
    const addr = state.address.find(addr=>addr.isActive)
    addr && (addr.isActive = false)
    state.address.find(addr=>addr.id==id).isActive = true
  },
  [ADDRESS_SET_DEFAULT_ADDRESS](state, id) {
    const addr = state.address.find(addr=>addr.isDefault)
    addr && (addr.isDefault = false)
    state.address.find(addr=>addr.id==id).isDefault = true
  }
}
const actions = {
  getAllAddress({ commit }) {
    get().then(adds=>commit(ADDRESS_GET_ADDRESS_LIST, adds))
  },
  setActiveAddress({ commit },id) {
    commit(ADDRESS_SET_ACTIVE_ADDRESS, id)
  },
  setDefaultAddress({ dispatch },id) {
    setDefault(id)
    .then(()=>dispatch('getAllAddress'))  //TODO 考虑是否不走借口更新本地数据
  },
  removeAddress({ dispatch },id){
    remove(id)
    .then(()=>dispatch('getAllAddress')) //TODO 考虑是否不走借口更新本地数据
  },
  addAddress({ dispatch },address){
    add(address)
    .then(_=>{
      dispatch('getAllAddress')
      router.go(-1);
    }) //TODO 考虑是否不走借口更新本地数据
  },
  editAddress({ dispatch },address){
    edit(address)
    .then(_=>{
      dispatch('getAllAddress')
      router.go(-1);
    }) //TODO 考虑是否不走借口更新本地数据
  },
  /**
   * 清空 本地缓存
   * @param {*} param0
   */
  clearLocalAddress({ commit }){
    commit(ADDRESS_GET_ADDRESS_LIST,[])
  }
}

export default {
  namespaced: true, // 添加命名空间
  state,
  getters,
  mutations,
  actions
}
